unit settings.useraccess;

interface

uses
  System.SysUtils, System.Classes, System.UITypes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  WEBLib.DBCtrls, WEBLib.DB, Vcl.Grids, Vcl.Menus, WEBLib.Buttons, WEBLib.Grids,
  XData.Web.Client, VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics,
  VCL.TMSFNCGraphicsTypes, System.Rtti, VCL.TMSFNCDataGridCell,
  VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase, VCL.TMSFNCDataGridCore,
  VCL.TMSFNCDataGridRenderer, VCL.TMSFNCBitmapContainer,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid;

type
  TfrmUserAccess = class(TForm)
    wpMain: TPanel;
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    btnClose: TButton;
    dsUserAccess: TDataSource;
    WebLabel1: TLabel;
    WebScrollBox1: TScrollBox;
    btnShowPassword: TButton;
    btnMailPassword: TButton;
    btnWhatsApp: TButton;
    btnNewUser: TButton;
    MessDlg: TMessageDlg;
    wdsUserAccess: TXDataWebDataSet;
    wcUsersAccess: TXDataWebClient;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    dgdbaUserAccess: TTMSFNCDataGridDatabaseAdapter;
    wdsUserAccessSLNCODE: TStringField;
    wdsUserAccessSLNNAME: TStringField;
    wdsUserAccessEMAIL: TStringField;
    wdsUserAccessPASSWORD: TStringField;
    wdsUserAccessACCESSRIGHTS: TStringField;
    BitmapContainer1: TTMSFNCBitmapContainer;
    WebPanel3: TPanel;
    edtUsersPagecount: TEdit;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    wdsUserAccesscellnumber: TStringField;
    wdsUserAccesssmsdieselerrors: TStringField;
    procedure btnCloseClick(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure XDataWebDataSet1AfterPost(DataSet: TDataSet);
    procedure WebFormShow(Sender: TObject);
    procedure WebDBGrid1GetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure btnShowPasswordClick(Sender: TObject);
    procedure btnNewUserClick(Sender: TObject);
    procedure TMSFNCDataGrid1GetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure TMSFNCDataGrid1CellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
  private
    { Private declarations }

    iUsersPagecount, iUsersMaxPC : Integer;

    procedure LoadUsers;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmUserAccess: TfrmUserAccess;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  settings.useraccesssetup;

procedure TfrmUserAccess.btnCloseClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmUserAccess.btnNewUserClick(Sender: TObject);
  var
    LFrm : TfrmUserAccessSetup;
  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmUserAccessSetup) do
      begin
        sUser := '';
        iState := 1;
      end;
  end;
  procedure AfterShoWModal(AValue: TModalResult);
  begin
    //wdsUserAccess.Close;
    //wdsUserAccess.Load;
    //LFrm.WebDBEdit1.Text;
  end;
begin
  LFrm := TfrmUserAccessSetup.CreateNew(@AfterCreate);

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;
  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmUserAccess.btnShowPasswordClick(Sender: TObject);
begin
  MessDlg.ShowDialog(wdsUserAccess.FieldByName('password').AsString,
                     WebLib.Dialogs.mtInformation, [mbOK]);
end;

procedure TfrmUserAccess.LoadUsers;
var
  sJson : String;


  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsUserAccess.Close;
      wdsUserAccess.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsUserAccess.Open;
    end;

  procedure OnSuccessPC(Response : TXDataClientResponse);
    begin
      iUsersMaxPC := Integer(TJSObject(Response.Result)['value']);

      edtUsersPagecount.Text := IntToStr(iUsersPagecount) + ' of ' + IntToStr(iUsersMaxPC);

      sJson := '{"PageCount":' + IntToStr(iUsersPagecount) + ',"SLNCode":"*"}';

      wcUsersAccess.RawInvoke('IstfmsSystemService.Get_WorkEmail_View',[sJson],@OnSuccess,@OnError);
    end;

begin
  wcUsersAccess.RawInvoke('IstfmsSystemService.Get_WorkEmail_MaxPC',[],@OnSuccessPC,@OnError);
end;

procedure TfrmUserAccess.TMSFNCDataGrid1CellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
    LFrm : TfrmUserAccessSetup;
    user : String;
  procedure AfterCreate(AForm : TObject);
  begin

    with (AForm as TfrmUserAccessSetup) do
      begin
        sUser := user;
        iState := 2;
      end;
  end;
  procedure AfterShoWModal(AValue: TModalResult);
  begin
    wdsUserAccess.Close;
    wdsUserAccess.Load;
    //LFrm.WebDBEdit1.Text;
  end;

begin
  if AColumn = 8 then
    Begin
      dgdbaUserAccess.SetActiveRecord(ARow);
      user := dgdbaUserAccess.FieldAtColumn[1].AsString;

      LFrm := TfrmUserAccessSetup.CreateNew(@AfterCreate);

      // LFrm als Pop-Up festlegen
      LFrm.Popup := true;

      // Transparenz definieren
      LFrm.PopupOpacity := 0.2;
      LFrm.ShowModal(@AfterShowModal);

    End;

  if AColumn = 9 then
    Begin

    End;
end;

procedure TfrmUserAccess.TMSFNCDataGrid1GetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dgdbaUserAccess.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column = 8 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[1];

      if ACell.Column = 9 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[0];
    end;
end;

procedure TfrmUserAccess.WebDBGrid1GetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
{  var
    btn : TWebButton;
  procedure btnShowSetupClick(Sender: TObject);
    var
      LFrm : TfrmUserAccessSetup;
    procedure AfterCreate(AForm : TObject);
    begin
      with (AForm as TfrmUserAccessSetup) do
        begin
          wdsUserAccess.First;
          wdsUserAccess.MoveBy(ARow - 1);
          sUser := wdsUserAccess.FieldByName('slncode').asString;
          bAppend := False;
        end;
    end;
    procedure AfterShoWModal(AValue: TModalResult);
    begin
      //wdsUserAccess.Close;
      //wdsUserAccess.Load;
    end;
  begin
    LFrm := TfrmUserAccessSetup.CreateNew(@AfterCreate);

    // LFrm als Pop-Up festlegen
    LFrm.Popup := true;

    // Transparenz definieren
    LFrm.PopupOpacity := 0.2;
    LFrm.ShowModal(@AfterShowModal);
  end;      }
begin
 { if ARow < 1 then
    exit;
  if ACol = 7 then
    begin
      btn := TWebButton.Create(self);
      btn.Caption := 'Edit';
      btn.Width := WebDBGrid1.Columns[ACol].Width;
      btn.Height := 25; //WebDBGrid1.DefaultRowHeight-2;
      btn.Color := $00ECA23B; //$FFE0FFFF;
      btn.Font.Color := clWhite;
      AElement.element.innerHTML := '';
      btn.ParentElement := AElement.element;
      btn.OnClick := btnShowSetupClick;
    end;   }
end;

procedure TfrmUserAccess.WebFormResize(Sender: TObject);
begin
  wpMain.Left := (Width - wpMain.Width) div 2;
  wpMain.Top := (Height - wpMain.Height) div 2;
end;

procedure TfrmUserAccess.WebFormShow(Sender: TObject);
begin
  //wdsUserAccess.Close;
  //wdsUserAccess.Load;
  iUsersPagecount := 1;
  LoadUsers;

  if dmdata.LStorage.getvalue(stfmssystem.connection.UserName) = 'SUPPORT' then
    begin
     btnShowPassword.Visible := True;
     btnMailPassword.Visible := True;
     btnWhatsApp.Visible := True;
    end;
end;

procedure TfrmUserAccess.WebSpeedButton1Click(Sender: TObject);
begin
  iUsersPagecount := 1;
  LoadUsers;
end;

procedure TfrmUserAccess.WebSpeedButton2Click(Sender: TObject);
begin
  if iUsersPagecount > 1 then
    Begin
      iUsersPagecount := iUsersPagecount - 1;
      LoadUsers;
    End;
end;

procedure TfrmUserAccess.WebSpeedButton3Click(Sender: TObject);
begin
  if iUsersPagecount < iUsersMaxPC then
    Begin
      iUsersPagecount := iUsersPagecount + 1;
      LoadUsers;
    End;
end;

procedure TfrmUserAccess.WebSpeedButton4Click(Sender: TObject);
begin
  iUsersPagecount := iUsersMaxPC;
  LoadUsers;
end;

procedure TfrmUserAccess.XDataWebDataSet1AfterPost(DataSet: TDataSet);
begin
  wdsUserAccess.ApplyUpdates;
end;

procedure TfrmUserAccess.LoadDFMValues;
begin
  inherited LoadDFMValues;

  wpMain := TPanel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  btnClose := TButton.Create(Self);
  btnShowPassword := TButton.Create(Self);
  btnMailPassword := TButton.Create(Self);
  btnWhatsApp := TButton.Create(Self);
  btnNewUser := TButton.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  BitmapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  WebScrollBox1 := TScrollBox.Create(Self);
  MessDlg := TMessageDlg.Create(Self);
  TMSFNCDataGrid1 := TTMSFNCDataGrid.Create(Self);
  dgdbaUserAccess := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  edtUsersPagecount := TEdit.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  dsUserAccess := TDataSource.Create(Self);
  wdsUserAccess := TXDataWebDataSet.Create(Self);
  wdsUserAccessSLNCODE := TStringField.Create(Self);
  wdsUserAccessSLNNAME := TStringField.Create(Self);
  wdsUserAccessEMAIL := TStringField.Create(Self);
  wdsUserAccessPASSWORD := TStringField.Create(Self);
  wdsUserAccessACCESSRIGHTS := TStringField.Create(Self);
  wdsUserAccesscellnumber := TStringField.Create(Self);
  wdsUserAccesssmsdieselerrors := TStringField.Create(Self);
  wcUsersAccess := TXDataWebClient.Create(Self);

  wpMain.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  btnShowPassword.BeforeLoadDFMValues;
  btnMailPassword.BeforeLoadDFMValues;
  btnWhatsApp.BeforeLoadDFMValues;
  btnNewUser.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  BitmapContainer1.BeforeLoadDFMValues;
  WebScrollBox1.BeforeLoadDFMValues;
  MessDlg.BeforeLoadDFMValues;
  TMSFNCDataGrid1.BeforeLoadDFMValues;
  dgdbaUserAccess.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  edtUsersPagecount.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  dsUserAccess.BeforeLoadDFMValues;
  wdsUserAccess.BeforeLoadDFMValues;
  wdsUserAccessSLNCODE.BeforeLoadDFMValues;
  wdsUserAccessSLNNAME.BeforeLoadDFMValues;
  wdsUserAccessEMAIL.BeforeLoadDFMValues;
  wdsUserAccessPASSWORD.BeforeLoadDFMValues;
  wdsUserAccessACCESSRIGHTS.BeforeLoadDFMValues;
  wdsUserAccesscellnumber.BeforeLoadDFMValues;
  wdsUserAccesssmsdieselerrors.BeforeLoadDFMValues;
  wcUsersAccess.BeforeLoadDFMValues;
  try
    Name := 'frmUserAccess';
    Width := 1024;
    Height := 768;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    wpMain.SetParentComponent(Self);
    wpMain.Name := 'wpMain';
    wpMain.Left := 0;
    wpMain.Top := 0;
    wpMain.Width := 1024;
    wpMain.Height := 768;
    wpMain.ElementClassName := 'card';
    wpMain.Align := alClient;
    wpMain.Color := clSilver;
    wpMain.ElementBodyClassName := 'card-body';
    wpMain.ElementFont := efCSS;
    wpMain.TabOrder := 0;
    WebPanel1.SetParentComponent(wpMain);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 703;
    WebPanel1.Width := 1024;
    WebPanel1.Height := 65;
    WebPanel1.ElementClassName := 'card';
    WebPanel1.Align := alBottom;
    WebPanel1.BorderStyle := bsNone;
    WebPanel1.ChildOrder := 1;
    WebPanel1.ElementBodyClassName := 'card-body';
    WebPanel1.ElementFont := efCSS;
    WebPanel1.ShowCaption := False;
    WebPanel1.TabOrder := 0;
    btnClose.SetParentComponent(WebPanel1);
    btnClose.Name := 'btnClose';
    btnClose.Left := 882;
    btnClose.Top := 6;
    btnClose.Width := 139;
    btnClose.Height := 49;
    btnClose.Caption := 'Close';
    btnClose.Color := clCrimson;
    btnClose.Font.Charset := DEFAULT_CHARSET;
    btnClose.Font.Color := clWhite;
    btnClose.Font.Height := -13;
    btnClose.Font.Name := 'Tahoma';
    btnClose.Font.Style := [];
    btnClose.HeightStyle := ssAuto;
    btnClose.HeightPercent := 100.000000000000000000;
    btnClose.ParentFont := False;
    btnClose.WidthPercent := 100.000000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnShowPassword.SetParentComponent(WebPanel1);
    btnShowPassword.Name := 'btnShowPassword';
    btnShowPassword.Left := 17;
    btnShowPassword.Top := 6;
    btnShowPassword.Width := 139;
    btnShowPassword.Height := 49;
    btnShowPassword.Caption := 'Show Password';
    btnShowPassword.Color := clLightseagreen;
    btnShowPassword.ChildOrder := 1;
    btnShowPassword.Font.Charset := DEFAULT_CHARSET;
    btnShowPassword.Font.Color := clWhite;
    btnShowPassword.Font.Height := -13;
    btnShowPassword.Font.Name := 'Tahoma';
    btnShowPassword.Font.Style := [];
    btnShowPassword.HeightStyle := ssAuto;
    btnShowPassword.HeightPercent := 100.000000000000000000;
    btnShowPassword.ParentFont := False;
    btnShowPassword.Visible := False;
    btnShowPassword.WidthPercent := 100.000000000000000000;
    SetEvent(btnShowPassword, Self, 'OnClick', 'btnShowPasswordClick');
    btnMailPassword.SetParentComponent(WebPanel1);
    btnMailPassword.Name := 'btnMailPassword';
    btnMailPassword.Left := 162;
    btnMailPassword.Top := 6;
    btnMailPassword.Width := 139;
    btnMailPassword.Height := 49;
    btnMailPassword.Caption := 'E-Mail';
    btnMailPassword.Color := clLightseagreen;
    btnMailPassword.ChildOrder := 2;
    btnMailPassword.Font.Charset := DEFAULT_CHARSET;
    btnMailPassword.Font.Color := clWhite;
    btnMailPassword.Font.Height := -13;
    btnMailPassword.Font.Name := 'Tahoma';
    btnMailPassword.Font.Style := [];
    btnMailPassword.HeightStyle := ssAuto;
    btnMailPassword.HeightPercent := 100.000000000000000000;
    btnMailPassword.ParentFont := False;
    btnMailPassword.Visible := False;
    btnMailPassword.WidthPercent := 100.000000000000000000;
    SetEvent(btnMailPassword, Self, 'OnClick', 'btnCloseClick');
    btnWhatsApp.SetParentComponent(WebPanel1);
    btnWhatsApp.Name := 'btnWhatsApp';
    btnWhatsApp.Left := 310;
    btnWhatsApp.Top := 6;
    btnWhatsApp.Width := 139;
    btnWhatsApp.Height := 49;
    btnWhatsApp.Caption := 'WhatsApp';
    btnWhatsApp.Color := clLightseagreen;
    btnWhatsApp.ChildOrder := 3;
    btnWhatsApp.Font.Charset := DEFAULT_CHARSET;
    btnWhatsApp.Font.Color := clWhite;
    btnWhatsApp.Font.Height := -13;
    btnWhatsApp.Font.Name := 'Tahoma';
    btnWhatsApp.Font.Style := [];
    btnWhatsApp.HeightStyle := ssAuto;
    btnWhatsApp.HeightPercent := 100.000000000000000000;
    btnWhatsApp.ParentFont := False;
    btnWhatsApp.Visible := False;
    btnWhatsApp.WidthPercent := 100.000000000000000000;
    SetEvent(btnWhatsApp, Self, 'OnClick', 'btnCloseClick');
    btnNewUser.SetParentComponent(WebPanel1);
    btnNewUser.Name := 'btnNewUser';
    btnNewUser.Left := 465;
    btnNewUser.Top := 6;
    btnNewUser.Width := 139;
    btnNewUser.Height := 49;
    btnNewUser.Caption := 'New User';
    btnNewUser.Color := 15508027;
    btnNewUser.ChildOrder := 4;
    btnNewUser.Font.Charset := DEFAULT_CHARSET;
    btnNewUser.Font.Color := clWhite;
    btnNewUser.Font.Height := -13;
    btnNewUser.Font.Name := 'Tahoma';
    btnNewUser.Font.Style := [];
    btnNewUser.HeightStyle := ssAuto;
    btnNewUser.HeightPercent := 100.000000000000000000;
    btnNewUser.ParentFont := False;
    btnNewUser.WidthPercent := 100.000000000000000000;
    SetEvent(btnNewUser, Self, 'OnClick', 'btnNewUserClick');
    WebPanel2.SetParentComponent(wpMain);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 1024;
    WebPanel2.Height := 33;
    WebPanel2.ElementClassName := 'card';
    WebPanel2.Align := alTop;
    WebPanel2.BorderStyle := bsNone;
    WebPanel2.ChildOrder := 1;
    WebPanel2.ElementBodyClassName := 'card-body';
    WebPanel2.ElementFont := efCSS;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -13;
    WebPanel2.Font.Name := 'Tahoma';
    WebPanel2.Font.Style := [];
    WebPanel2.ParentFont := False;
    WebPanel2.ShowCaption := False;
    WebPanel2.TabOrder := 1;
    WebLabel1.SetParentComponent(WebPanel2);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 1024;
    WebLabel1.Height := 33;
    WebLabel1.Align := alClient;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'User Setup';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -16;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    BitmapContainer1.SetParentComponent(WebPanel2);
    BitmapContainer1.Name := 'BitmapContainer1';
    BitmapContainer1.Left := 808;
    BitmapContainer1.Top := 8;
    BitmapContainer1.Width := 26;
    BitmapContainer1.Height := 26;
    BitmapContainer1.Visible := True;
    BitmapContainer1.Items.Clear;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('settings.useraccess.BitmapContainer1.Items.Bitmap.svg');
      Name := 'delete.svg';
      Tag := 0;
    end;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('settings.useraccess.BitmapContainer1.Items.Bitmap_1.svg');
      Name := 'edit.svg';
      Tag := 0;
    end;
    WebScrollBox1.SetParentComponent(wpMain);
    WebScrollBox1.Name := 'WebScrollBox1';
    WebScrollBox1.Left := 0;
    WebScrollBox1.Top := 33;
    WebScrollBox1.Width := 1024;
    WebScrollBox1.Height := 670;
    WebScrollBox1.ElementClassName := 'card';
    WebScrollBox1.Align := alClient;
    WebScrollBox1.BorderStyle := bsSingle;
    WebScrollBox1.ChildOrder := 3;
    MessDlg.SetParentComponent(WebScrollBox1);
    MessDlg.Name := 'MessDlg';
    MessDlg.Left := 592;
    MessDlg.Top := 168;
    MessDlg.Width := 24;
    MessDlg.Height := 24;
    MessDlg.Buttons := [mbOK];
    MessDlg.DialogType := mtInformation;
    MessDlg.Opacity := 0.200000000000000000;
    MessDlg.Title := 'User Password';
    MessDlg.ElementButtonClassName := 'btn';
    MessDlg.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    MessDlg.ElementTitleClassName := 'text-body';
    MessDlg.ElementContentClassName := 'text-body';
    TMSFNCDataGrid1.SetParentComponent(WebScrollBox1);
    TMSFNCDataGrid1.Name := 'TMSFNCDataGrid1';
    TMSFNCDataGrid1.Left := 0;
    TMSFNCDataGrid1.Top := 0;
    TMSFNCDataGrid1.Width := 1024;
    TMSFNCDataGrid1.Height := 610;
    TMSFNCDataGrid1.Align := alClient;
    TMSFNCDataGrid1.ParentDoubleBuffered := False;
    TMSFNCDataGrid1.DoubleBuffered := True;
    TMSFNCDataGrid1.TabOrder := 1;
    TMSFNCDataGrid1.ShowAcceleratorChar := False;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid1.Adapter := dgdbaUserAccess;
    TMSFNCDataGrid1.BitmapContainer := BitmapContainer1;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid1.ColumnCount := 10;
    TMSFNCDataGrid1.Columns.Clear;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := '.';
      Width := 25.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CODE';
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'NAME';
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'EMAIL';
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'PASSWORD';
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ACCESSRIGHTS';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'cellnumber';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'smsdieselerrors';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
      Settings := [gcsType,gcsEditorItems];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Delete';
      Settings := [gcsType,gcsEditorItems];
    end;
    TMSFNCDataGrid1.Designer := False;
    TMSFNCDataGrid1.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid1.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid1.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid1.Icons.ExpandIcon.LoadFromFile('settings.useraccess.WebScrollBox1.TMSFNCDataGrid1.Icons.ExpandIcon.svg');
    TMSFNCDataGrid1.Icons.CollapseIcon.LoadFromFile('settings.useraccess.WebScrollBox1.TMSFNCDataGrid1.Icons.CollapseIcon.svg');
    TMSFNCDataGrid1.Icons.FilterIcon.LoadFromFile('settings.useraccess.WebScrollBox1.TMSFNCDataGrid1.Icons.FilterIcon.svg');
    TMSFNCDataGrid1.Icons.FilterActiveIcon.LoadFromFile('settings.useraccess.WebScrollBox1.TMSFNCDataGrid1.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid1.Icons.FilterClearIcon.LoadFromFile('settings.useraccess.WebScrollBox1.TMSFNCDataGrid1.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid1.Icons.FilterTypeIcon.LoadFromFile('settings.useraccess.WebScrollBox1.TMSFNCDataGrid1.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid1.Icons.SortAscendingIcon.LoadFromFile('settings.useraccess.WebScrollBox1.TMSFNCDataGrid1.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid1.Icons.SortDescendingIcon.LoadFromFile('settings.useraccess.WebScrollBox1.TMSFNCDataGrid1.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid1.Icons.CloseIcon.LoadFromFile('settings.useraccess.WebScrollBox1.TMSFNCDataGrid1.Icons.CloseIcon.svg');
    SetEvent(TMSFNCDataGrid1, Self, 'OnCellClick', 'TMSFNCDataGrid1CellClick');
    SetEvent(TMSFNCDataGrid1, Self, 'OnGetCellProperties', 'TMSFNCDataGrid1GetCellProperties');
    TMSFNCDataGrid1.RowCount := 1;
    dgdbaUserAccess.SetParentComponent(TMSFNCDataGrid1);
    dgdbaUserAccess.Name := 'dgdbaUserAccess';
    dgdbaUserAccess.Left := 384;
    dgdbaUserAccess.Top := 144;
    dgdbaUserAccess.Width := 26;
    dgdbaUserAccess.Height := 26;
    dgdbaUserAccess.Visible := True;
    dgdbaUserAccess.Columns.Clear;
    with dgdbaUserAccess.Columns.Add do
    begin
      Header := '.';
      AutoCreated := False;
    end;
    with dgdbaUserAccess.Columns.Add do
    begin
      FieldName := 'SLNCODE';
      Header := 'CODE';
      AutoCreated := False;
    end;
    with dgdbaUserAccess.Columns.Add do
    begin
      FieldName := 'SLNNAME';
      Header := 'NAME';
      AutoCreated := False;
    end;
    with dgdbaUserAccess.Columns.Add do
    begin
      FieldName := 'EMAIL';
      Header := 'EMAIL';
      AutoCreated := False;
    end;
    with dgdbaUserAccess.Columns.Add do
    begin
      FieldName := 'PASSWORD';
      Header := 'PASSWORD';
      AutoCreated := False;
    end;
    with dgdbaUserAccess.Columns.Add do
    begin
      FieldName := 'ACCESSRIGHTS';
      Header := 'ACCESSRIGHTS';
      AutoCreated := False;
    end;
    with dgdbaUserAccess.Columns.Add do
    begin
      FieldName := 'cellnumber';
      Header := 'cellnumber';
      AutoCreated := False;
    end;
    with dgdbaUserAccess.Columns.Add do
    begin
      FieldName := 'smsdieselerrors';
      Header := 'smsdieselerrors';
      AutoCreated := False;
    end;
    with dgdbaUserAccess.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    with dgdbaUserAccess.Columns.Add do
    begin
      Header := 'Delete';
      AutoCreated := False;
    end;
    dgdbaUserAccess.DataSource := dsUserAccess;
    WebPanel3.SetParentComponent(WebScrollBox1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 610;
    WebPanel3.Width := 1024;
    WebPanel3.Height := 60;
    WebPanel3.ElementClassName := 'card';
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 2;
    WebPanel3.ElementBodyClassName := 'card-body';
    WebPanel3.ElementFont := efCSS;
    WebPanel3.TabOrder := 2;
    edtUsersPagecount.SetParentComponent(WebPanel3);
    edtUsersPagecount.Name := 'edtUsersPagecount';
    edtUsersPagecount.Left := 88;
    edtUsersPagecount.Top := 16;
    edtUsersPagecount.Width := 121;
    edtUsersPagecount.Height := 22;
    edtUsersPagecount.ElementClassName := 'form-control';
    edtUsersPagecount.ElementFont := efCSS;
    edtUsersPagecount.HeightStyle := ssAuto;
    edtUsersPagecount.HeightPercent := 100.000000000000000000;
    edtUsersPagecount.Text := 'edtUsersPagecount';
    edtUsersPagecount.WidthPercent := 100.000000000000000000;
    WebSpeedButton1.SetParentComponent(WebPanel3);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 17;
    WebSpeedButton1.Top := 16;
    WebSpeedButton1.Width := 24;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.ElementClassName := 'btn btn-light';
    WebSpeedButton1.ElementFont := efCSS;
    WebSpeedButton1.HeightStyle := ssAuto;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 1;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(WebPanel3);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 47;
    WebSpeedButton2.Top := 16;
    WebSpeedButton2.Width := 24;
    WebSpeedButton2.Height := 24;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.ElementClassName := 'btn btn-light';
    WebSpeedButton2.ElementFont := efCSS;
    WebSpeedButton2.HeightStyle := ssAuto;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 2;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(WebPanel3);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 232;
    WebSpeedButton3.Top := 16;
    WebSpeedButton3.Width := 24;
    WebSpeedButton3.Height := 24;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.ElementClassName := 'btn btn-light';
    WebSpeedButton3.ElementFont := efCSS;
    WebSpeedButton3.HeightStyle := ssAuto;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 3;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(WebPanel3);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 262;
    WebSpeedButton4.Top := 16;
    WebSpeedButton4.Width := 24;
    WebSpeedButton4.Height := 24;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.ElementClassName := 'btn btn-light';
    WebSpeedButton4.ElementFont := efCSS;
    WebSpeedButton4.HeightStyle := ssAuto;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 4;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    dsUserAccess.SetParentComponent(Self);
    dsUserAccess.Name := 'dsUserAccess';
    dsUserAccess.DataSet := wdsUserAccess;
    dsUserAccess.Left := 296;
    dsUserAccess.Top := 168;
    wdsUserAccess.SetParentComponent(Self);
    wdsUserAccess.Name := 'wdsUserAccess';
    wdsUserAccess.Connection := dmData.dbConnect;
    wdsUserAccess.Left := 208;
    wdsUserAccess.Top := 169;
    wdsUserAccessSLNCODE.SetParentComponent(wdsUserAccess);
    wdsUserAccessSLNCODE.Name := 'wdsUserAccessSLNCODE';
    wdsUserAccessSLNCODE.FieldName := 'SLNCODE';
    wdsUserAccessSLNNAME.SetParentComponent(wdsUserAccess);
    wdsUserAccessSLNNAME.Name := 'wdsUserAccessSLNNAME';
    wdsUserAccessSLNNAME.FieldName := 'SLNNAME';
    wdsUserAccessEMAIL.SetParentComponent(wdsUserAccess);
    wdsUserAccessEMAIL.Name := 'wdsUserAccessEMAIL';
    wdsUserAccessEMAIL.FieldName := 'EMAIL';
    wdsUserAccessPASSWORD.SetParentComponent(wdsUserAccess);
    wdsUserAccessPASSWORD.Name := 'wdsUserAccessPASSWORD';
    wdsUserAccessPASSWORD.FieldName := 'PASSWORD';
    wdsUserAccessACCESSRIGHTS.SetParentComponent(wdsUserAccess);
    wdsUserAccessACCESSRIGHTS.Name := 'wdsUserAccessACCESSRIGHTS';
    wdsUserAccessACCESSRIGHTS.FieldName := 'ACCESSRIGHTS';
    wdsUserAccesscellnumber.SetParentComponent(wdsUserAccess);
    wdsUserAccesscellnumber.Name := 'wdsUserAccesscellnumber';
    wdsUserAccesscellnumber.FieldName := 'cellnumber';
    wdsUserAccesssmsdieselerrors.SetParentComponent(wdsUserAccess);
    wdsUserAccesssmsdieselerrors.Name := 'wdsUserAccesssmsdieselerrors';
    wdsUserAccesssmsdieselerrors.FieldName := 'smsdieselerrors';
    wcUsersAccess.SetParentComponent(Self);
    wcUsersAccess.Name := 'wcUsersAccess';
    wcUsersAccess.Connection := dmData.dbConnect;
    wcUsersAccess.Left := 120;
    wcUsersAccess.Top := 169;
  finally
    wpMain.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    btnShowPassword.AfterLoadDFMValues;
    btnMailPassword.AfterLoadDFMValues;
    btnWhatsApp.AfterLoadDFMValues;
    btnNewUser.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    BitmapContainer1.AfterLoadDFMValues;
    WebScrollBox1.AfterLoadDFMValues;
    MessDlg.AfterLoadDFMValues;
    TMSFNCDataGrid1.AfterLoadDFMValues;
    dgdbaUserAccess.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    edtUsersPagecount.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    dsUserAccess.AfterLoadDFMValues;
    wdsUserAccess.AfterLoadDFMValues;
    wdsUserAccessSLNCODE.AfterLoadDFMValues;
    wdsUserAccessSLNNAME.AfterLoadDFMValues;
    wdsUserAccessEMAIL.AfterLoadDFMValues;
    wdsUserAccessPASSWORD.AfterLoadDFMValues;
    wdsUserAccessACCESSRIGHTS.AfterLoadDFMValues;
    wdsUserAccesscellnumber.AfterLoadDFMValues;
    wdsUserAccesssmsdieselerrors.AfterLoadDFMValues;
    wcUsersAccess.AfterLoadDFMValues;
  end;
end;

end.